import React from 'react';
import { ageDescription, arrayToString, arrayToStringComplex, htmlForDescription, htmlForFilter, htmlForType, stringForDescription, stringForFilter, stringForType } from '../CohortBuilder/CohortUtil';
import { isNotBlank } from '../../reducers/util';
import {Group, ReportConfig} from "./types/CohortReport";

const ReportSummary = (reportConfig: ReportConfig) => {

    const html = true
    const decorateType = html ? htmlForType : stringForType
    const decorateDescription = html ? htmlForDescription : stringForDescription
    const decorateFilter = html ? htmlForFilter : stringForFilter

    const describeGroupFilters = (group: Group) => {

        const describe = () => {
            const ageText = ageDescription(group.fromAge, group.toAge)

            const startText = [
                arrayToString(decorateType('Gender'), decorateDescription, group.gender),
                isNotBlank(ageText) ? decorateType('Age') + decorateDescription(ageText) : ''
            ].filter(i => i.length > 0).join(', ')

            const description = [
                startText,
                decorateType('Diagnosis Type') + decorateDescription(group.diagnonsisOr ? "OR" : "AND"),
                arrayToStringComplex(decorateType('Primary Diagnosis'), decorateDescription, group.primaryDiagnosis),
                arrayToStringComplex(decorateType('Secondary Diagnosis'), decorateDescription, group.secondaryDiagnosis),
                arrayToStringComplex(decorateType('Treatments'), decorateDescription, group.treatments),
                arrayToStringComplex(decorateType('Provider Trusts'), decorateDescription, group.trusts),
                arrayToStringComplex(decorateType('Sub ICB Locations'), decorateDescription, group.subICBLocations),
                arrayToStringComplex(decorateType('Trusts'), decorateDescription, group.trusts),
                arrayToStringComplex(decorateType('Procedures'), decorateDescription, group.procedures),
            ].filter(i => i.length > 0).map(i => decorateFilter(i)).join(html ? '' : ', ')

            return description
        }

        return describe()
    }

    const allDescriptions = [
        reportConfig.group1,
        reportConfig.group2,
        reportConfig.group3,
    ]
        .flat()
        .map(filter => {
            return {
                id: filter.id,
                level: filter.level,
                title: filter.title,
                description: describeGroupFilters(filter)
            }
        })
        .map(i => {
            return <tr key={i.id} className={"group-" + i.level}>
                <td>Group {i.level}</td>
                <td>{i.title}</td>
                <td dangerouslySetInnerHTML={{ __html: i.description }}></td>
            </tr>
        })

    return (
        <table className="report-summary">
            <thead>
                <tr>
                    <td>Group Level</td>
                    <td>Group Label</td>
                    <td>Group Description</td>
                </tr>
            </thead>
            <tbody>
                {allDescriptions}
            </tbody>
        </table>
    )
}

export default ReportSummary